import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (authService.currentUser !== null) {
    return true;
  }

  if (isPlatformBrowser(platformId)) {
    sessionStorage.setItem('craftly:redirectUrl', state.url);
  }

  return router.createUrlTree(['/login'], { queryParams: { redirect: state.url } });
};
